module.exports = __webpack_public_path__ + "67efa6fd608bdf85c814dfeebd87ccf3.MP3";